/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Row, Col, Table } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import mBarang from './Barang.controller'


const Export = (props) => {
    const clientID = props.clientID
    const token = props.token
    const kodeoutlet = props.kodeoutlet
    const [isReload, setIsReload] = useState(true)
    const [listData, setListData] = useState([])
    useEffect(() => {
        mBarang.loadExport(kodeoutlet, clientID, token).then(resp => {
            setListData(resp);
        }).catch(err => {
            console.error(err);
        }).finally(() => setIsReload(false))
        return () => {

        }
    }, [isReload])
    return (
        <Row>
            <Col xs={12}>
                {!isReload && (
                    <ReactHTMLTableToExcel
                        className="buttonExportExcel"
                        table="exportData"
                        filename="Barang"
                        sheet="Sheet1"
                        buttonText=" Export Excel " />
                )}
                <Table id="exportData" striped bordered hover responsive="lg" style={{ display: "none" }}>
                    <thead>
                        <tr className="colorWhite bgHeaderTabel tabelCenter">
                            <th>Kode Kategori</th>
                            <th>Nama Kategori</th>
                            <th>Kode Kategori</th>
                            <th>Kode Sub Kategori</th>
                            <th>Satuan</th>
                            <th>Harga Satuan</th>
                            <th>Harga Gojek</th>
                            <th>Harga Grab</th>
                            <th>Harga Lain</th>
                            <th>Manajemen Stok</th>
                            <th>Manajemen Printer</th>
                            <th>Aktif</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listData.map((el, i) => {
                            return (
                                <tr key={i}>
                                    <td>{el.kodebarang}</td>
                                    <td>{el.namabarang}</td>
                                    <td>{el.kodekategori}</td>
                                    <td>{el.kodesubkategori}</td>
                                    <td>{el.satuan}</td>
                                    <td>{el.hargasatuan}</td>
                                    <td>{el.hargagojek}</td>
                                    <td>{el.hargagrab}</td>
                                    <td>{el.hargalain}</td>
                                    <td>{el.isStock ? "TRUE":"FALSE"}</td>
                                    <td>{el.printer}</td>
                                    <td> {el.isHide ? "NO" : "YES"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </Col>
        </Row>
    );
}
export default Export;